var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReportHeatmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 7.5,
    stroke: "var(--report-widget-icon-stroke-outer)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 6,
    height: 3,
    rx: 1,
    fill: "#F37321"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 13,
    width: 6,
    height: 3,
    rx: 1,
    fill: "var(--report-widget-icon-stroke-dark)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 13,
    width: 6,
    height: 3,
    rx: 1,
    fill: "var(--report-widget-icon-stroke-dark)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 17,
    width: 6,
    height: 3,
    rx: 1,
    fill: "var(--report-widget-icon-stroke-dark)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 18,
    y: 17,
    width: 6,
    height: 3,
    rx: 1,
    fill: "var(--report-widget-icon-stroke-dark)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 6,
    height: 3,
    rx: 1,
    fill: "#F37321"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 21,
    width: 6,
    height: 3,
    rx: 1,
    fill: "#F37321"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 18,
    y: 21,
    width: 6,
    height: 3,
    rx: 1,
    fill: "var(--report-widget-icon-stroke-dark)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 25,
    y: 21,
    width: 6,
    height: 3,
    rx: 1,
    fill: "var(--report-widget-icon-stroke-dark)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 11,
    y: 25,
    width: 6,
    height: 3,
    rx: 1,
    fill: "var(--report-widget-icon-stroke-dark)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 18,
    y: 25,
    width: 6,
    height: 3,
    rx: 1,
    fill: "var(--report-widget-icon-stroke-dark)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 25,
    y: 25,
    width: 6,
    height: 3,
    rx: 1,
    fill: "var(--report-widget-icon-stroke-dark)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportHeatmap);
export default __webpack_public_path__ + "static/media/icon-report-heatmap.cb9924634510db4db5e8ab10412005ab.svg";
export { ForwardRef as ReactComponent };